import { getHiveflowConfig } from "@/lib/environment";

const DB_NAME = "hiveflow_offline_snapshot";
const STORE = "collections";
const VERSION = 1;

function ownerKey() {
  try {
    const user = JSON.parse(localStorage.getItem("imker_user") || "null");
    return user?.id ? `${user.organization_id || user.id}:${user.id}` : null;
  } catch {
    return null;
  }
}

function openDatabase() {
  const config = getHiveflowConfig();
  if (config.offlineBundle || (config.nativeBridgeEnabled && typeof window !== "undefined" && window.ReactNativeWebView)) {
    return Promise.reject(new Error("IndexedDB-snapshot is uitgeschakeld in de native WebView"));
  }
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, VERSION);
    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(STORE)) database.createObjectStore(STORE, { keyPath: "key" });
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function readRecord(key) {
  const database = await openDatabase();
  return new Promise((resolve, reject) => {
    const request = database.transaction(STORE, "readonly").objectStore(STORE).get(key);
    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error);
  });
}

export async function readSnapshotCollection(entityType, { includeDeleted = false, onlyDeleted = false } = {}) {
  const owner = ownerKey();
  if (!owner || !entityType) return [];
  const record = await readRecord(`${owner}:${entityType}`);
  if (!Array.isArray(record?.items)) return [];
  const deleted = (item) => Boolean(item?.isDeleted || item?._offline?.isDeleted || item?.deleted_at);
  if (onlyDeleted) return record.items.filter(deleted);
  if (includeDeleted) return record.items;
  return record.items.filter((item) => !deleted(item));
}

export async function storeSnapshotCollection(entityType, incoming, { replace = false } = {}) {
  const owner = ownerKey();
  const items = Array.isArray(incoming) ? incoming : incoming ? [incoming] : [];
  if (!owner || !entityType || (items.length === 0 && !replace)) return;
  const key = `${owner}:${entityType}`;
  const previous = replace ? [] : ((await readRecord(key))?.items || []);
  const merged = new Map(previous.map((item) => [String(item.id ?? item._offline?.entityId), item]));
  for (const item of items) {
    const id = item?.id ?? item?._offline?.entityId;
    if (id == null) continue;
    merged.set(String(id), { ...merged.get(String(id)), ...item });
  }
  const database = await openDatabase();
  await new Promise((resolve, reject) => {
    const request = database.transaction(STORE, "readwrite").objectStore(STORE).put({
      key,
      owner,
      entityType,
      items: [...merged.values()],
      cachedAt: new Date().toISOString(),
    });
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
}
